export const ZERO_PRICE_TEXT = '0,00';
